import dayjs from "dayjs";

export const toISOFromTimestampInSeconds = unixTimestamp => {
  return new Date(unixTimestamp * 1000).toUTCString();
};

export const formatDateFromTimestamp = (timestampInSeconds, { format = "MMMM D, YYYY h:ma" } = {}) => {
  return dayjs.unix(timestampInSeconds).format(format);
};
